module.exports = __webpack_public_path__ + "img/provider_GCP.fe5e4096.svg";